<style lang="less">
    .page_con.index{
        width:100vw;
        height:100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background:url("../assets/images/topbar.png") no-repeat;
            background-size: 100% 100%;
            >div{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;
                .name{
                    font-size: .5rem;
                    // letter-spacing: .1rem;
                    color:#fff;
                }
                .school{
                    font-size: .1rem;
                    color:#fff;
                    letter-spacing: .03rem;
                }
                .score{
                    font-size: .5rem;
                    color:#fff;
                }
                .score_tag{
                    font-size: .1rem;
                    color:#fff;
                    width:100%;
                    border:.01rem solid #fff;
                    border-radius: .1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        padding:0 .1rem;
                    }
                }
            }
        }
        .lv{
            position: absolute;
            top:13vh;
            right:2vw;
            z-index: 11;
        }
        .lv_con{
            width:30vw;
            height:auto;
            overflow: hidden;
            position: relative;
            img{
                width:100%;
                height:auto;
                display: block;
            }
            span{
                color:#fff;
                font-size: .3rem;
                position: absolute;
                left:50%;
                top:47%;
                z-index: 11;
                transform: translate(-50%,-50%);
            }
        }
        .content{
            width:100%;
            flex:1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            >div{
                img{
                    width:60%;
                    height:auto;
                    display: block;
                    margin:0 auto .05rem;
                }
                .active{
                    display: none;
                }
                .none{
                    display: block;
                }
            }
            >div.active{
                .active{
                    display: block;
                }
                .none{
                    display: none;
                }
            }
        }
        .bottom_con{
            width:100%;
            height:8vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #E5A840;
            .item{
                flex:1;
                color:#fff;
                font-size: .45rem;
                letter-spacing: .15rem;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                img{
                    width:10vw;
                    height:auto;
                    display: block;
                    position: absolute;
                    top:0;
                    right:0;
                    z-index: 11;
                    transform: translate(-17%, -80%);
                }
                a{
                    color:#fff;
                }
            }
        }
    }
    .dialog{
        width:100vw;
        height:100vh;
        position: fixed;
        top:0;
        left: 0;
        z-index: 111;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background:url("../assets/images/bg3.png") no-repeat;
        p.title{
            font-size: .64rem;
            text-align: center;
            margin-bottom: .5rem;
            letter-spacing: .3rem;
        }
        p{
            width: 100%;
            line-height: 2;
            text-align: left;
            padding:0 15vw;
            margin-bottom: .2rem;
            font-size: .28rem;
            span{
                color:crimson;
            }
            a{
                color:rgb(26, 26, 161);
                text-decoration: underline;
            }
        }
        .btn{
            width:30vw;
            display: block;
            margin-top:1rem;
        }
    }
</style>
<template>
    <div class="page_con index">
        <div class="top_con">
            <div class="top_lf">
                <span class="name">{{$store.getters.userInfo.Name}}</span>
                <span class="school">{{$store.getters.userInfo.SchoolName}}</span>
            </div>
            <div class="top_rt">
                <span class="score">{{$store.getters.userInfo.score}}</span>
                <div class="score_tag">
                    <span>成</span>
                    <span>績</span>
                </div>
            </div>
        </div>
        <div class="lv">
            <div class="lv_con">
                <img class="lv_con" src="../assets/images/grade-button.png" alt="">
                <span>等級 {{$store.getters.userInfo.lv}}</span>
            </div>
        </div>
        <div class="content">
            <template v-for="(item,index) in menu">
                <div :key="index" :class="{'active':item.played == 1}" v-if="item.played == 1">
                    <router-link :to="item.route">
                        <img class="active" :src="require('../assets/images/'+item.id+'.png')" alt="">
                    </router-link>
                </div>
                <div :key="index" :class="{'active':item.played == 1}" v-else>
                        <img class="none" :src="require('../assets/images/'+item.id+'none.png')" alt="">
                </div>
            </template>
        </div>
        <div class="bottom_con">
            <div class="item">
                <div class="text">通告</div>
                <!-- <img src="../assets/images/new.png" alt=""> -->
            </div>
            <div class="item">
                <div class="text">
                    <router-link to="/score">成績</router-link>
                </div>
            </div>
            <div class="item">
                <div class="text" @click="logout">登出</div>
                <!-- <div class="text" @click="showDialog=true">登出</div> -->
            </div>
        </div>
        <!-- <div class="dialog" v-show="showDialog">
            <p class="title">注意</p>
            <p>「每日一詞」和「每日一練」計劃本學年定於 <span>2021年5月23日完結，不設補讀。</span></p>
            <p>5月23日至30日同學仍可登入查看成績。</p>
            <p>
                <span>新學年</span>之學習日期如下：<br>
                2021 年 10 月 11 日---2022年5 月15 日<br>
                歡迎以學校名義或個人名義報名
            </p>
            <p>請情見布告板 <a href="www.hk-123.com">www.hk-123.com</a></p>
            <img class="btn" @click="logout" src="../assets/images/certain-button.png" alt="">
        </div> -->
    </div>
</template>
<script>
export default {
    data(){
        return {
            showDialog:false,
            day:2,
            menu:[
                {
                    id:1,
                    route:'/read',  //粤语读音
                    type:'7',
                    played:0,
                },
                {
                    id:2,
                    route:'/correct',   //字词订正
                    type:'8',
                    played:0,
                },
                {
                    id:3,
                    route:'/combo',     //组词接龙
                    type:'9',
                    played:0,
                },
                {
                    id:4,
                    route:'/polysemy',  //一词多义
                    type:'10',
                    played:0,
                },
                {
                    id:5,
                    route:'/assembly',  //词语搭配
                    type:'11',
                    played:0,
                },
                {
                    id:6,
                    route:'/sentence',  //句子订正
                    type:'12',
                    played:0,
                },
            ],
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            let vm = this;
            this.$http.get('/IndexDaily/gameList?rest_key=1').then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setUserInfo',res.data.data.user);
                    let arr = res.data.data.gameList;
                    arr.forEach(v=>{
                        vm.menu.forEach(val=>{
                            if(v.game_type == val.type){
                                val.played = v.played;
                            }
                        });
                    });
                }
            })
        },
        logout(){
            let vm = this;
            this.$http.get(this.baseUrl+'/User/logout.html?rest_key=1').then(res=>{
                console.log(1111);
                vm.$router.push('/login');
            }).catch(err=>{
                console.log(333);
                vm.$router.push('/login');
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index.vue